export const scrollToElementById = (parentElement: HTMLElement, elementId: string, offsetTop?: number, behavior: ScrollBehavior = "smooth") => {
    const section = window.document.getElementById(elementId);

    if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = parentElement === document.documentElement ? window.scrollY : parentElement.scrollTop;
        const top = rect.top + scrollTop;

        window.scrollTo({
            top: top - (offsetTop || 0),
            behavior
        });
    }
};
export const scrollToElementById = (parentElement: HTMLElement, elementId: string, offsetTop?: number, behavior: ScrollBehavior = "smooth") => {
    const section = window.document.getElementById(elementId);

    if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = parentElement === document.documentElement ? window.scrollY : parentElement.scrollTop;
        const top = rect.top + scrollTop;

        window.scrollTo({
            top: top - (offsetTop || 0),
            behavior
        });
    }
};
